export const StreakWarningBanner = ({
  showStreakWarning,
  getStreakWarningStatus,
  streak,
  setShowStreakWarning,
  setCurrentView,
}) => {
  if (!showStreakWarning || !getStreakWarningStatus()) return null;

  const status = getStreakWarningStatus();

  return (
    <div className={`fixed top-0 left-0 right-0 z-[150] animate-slide-in ${status.isCritical ? 'bg-gradient-to-r from-red-600 to-orange-600' : 'bg-gradient-to-r from-orange-600 to-yellow-600'
      } border-b-4 ${status.isCritical ? 'border-red-400' : 'border-orange-400'
      } px-4 py-3 shadow-2xl`}>
      <div className="max-w-4xl mx-auto relative" style={{ zIndex: 1 }}>
        <div className="flex items-center justify-between gap-3">
          <div className="flex items-center gap-3 flex-1">
            <div className={`${status.isCritical ? 'animate-pulse' : ''} text-2xl`}>
              {status.isCritical ? '🚨' : '⚠️'}
            </div>
            <div className="flex-1">
              <p className="text-white font-black text-sm sm:text-base uppercase leading-tight">
                {status.isCritical ? '🔥 STREAK DYING!' : '⏰ STREAK WARNING'}
              </p>
              <p className={`text-xs sm:text-sm font-bold ${status.isCritical ? 'text-red-100' : 'text-orange-100'}`}>
                {status.hoursRemaining}h {status.minutesRemaining}m until {streak} day streak breaks
              </p>
            </div>
          </div>
          <div className="flex items-center gap-2">
            <button
              onClick={() => setCurrentView('home')}
              className={`${status.isCritical
                ? 'bg-white text-red-600 border-white'
                : 'bg-black text-orange-400 border-orange-400'
                } px-3 sm:px-4 py-2 font-black text-xs sm:text-sm uppercase border-2 transition-all hover:scale-105`}
            >
              SEND NOW
            </button>
            <button
              onClick={() => setShowStreakWarning(false)}
              className="text-white hover:text-black font-black text-xl transition-all"
            >
              ✕
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
